module.exports = __webpack_public_path__ + "static/assets/d78173077f3d3114ca769ae1b6671098.png";